/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus, faEdit } from "@fortawesome/free-solid-svg-icons";
import BTable from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import "react-datetime/css/react-datetime.css";
import { useTable } from "react-table";
import "./Users.css";
import { httpClient } from "../../request";
import { statusToIcon } from "../../status";

/**
 * @todo Support pagination
 *
 * @param {*} param0
 */
function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  // Render the UI for your table
  return (
    <BTable striped bordered hover size="sm" {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </BTable>
  );
}

export default function Variables() {
  const [isLoading, setLoading] = useState(true);
  const [apps, setApps] = useState([]);
  const [variables, setVariables] = useState([]);
  const [result, setResult] = useState(false);
  const [appIDIndex, setAppIDIndex] = useState(-1);
  const [selectedData, setSelectedData] = useState(true);

  const [createShow, setCreateShow] = useState(false);
  const [editShow, setEditShow] = useState(false);

  const handleEditClose = () => setEditShow(false);
  const handleEditShow = () => setEditShow(true);

  const handleEditChange = (e) => {
    const { id, value } = e.target;
    setSelectedData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const [createData, setCreateData] = useState({
    name: "",
    value: "",
  });

  const handleCreateChange = (e) => {
    const { id, value } = e.target;
    setCreateData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleCreateClose = () => setCreateShow(false);
  const handleCreateShow = () => setCreateShow(true);

  const token = JSON.parse(localStorage.getItem("token"));

  const getCloudVariables = (appID) => {
    httpClient
      .get(`/private/variables?app=${appID}`, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        let variablesForApp = responseData.variables;
        if (variablesForApp) {
          for (let i = 0; i < variablesForApp.length; ++i) {
            variablesForApp[i].app = appID;
          }
        }

        setVariables(variablesForApp ? variablesForApp : []);

        setLoading(false);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const handleChangeAppID = (e) => {
    const { id, value } = e.target;
    setAppIDIndex(value);

    getCloudVariables(apps[value].PublicId);
  };

  const getApps = () => {
    httpClient
      .get("/private/apps", {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        setApps(responseData.apps ? responseData.apps : []);

        setLoading(false);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const deleteCloudVariable = (name, appID) => {
    httpClient
      .delete(`/private/variables/${name}?app=${appID}`, {
        headers: {
          Authorization: `Bearer ${token.token}`,
        },
      })
      .then((response) => {
        setResult({
          status: "success",
          message: "Deleted variable",
        });

        // Reload the users since our data changed
        getCloudVariables(appID);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const createCloudVariable = () => {
    httpClient
      .post(
        `/private/variables/${createData.name}?app=${apps[appIDIndex].PublicId}&value=${createData.value}`,
        null,
        {
          headers: {
            Authorization: "Bearer " + token.token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          setResult({
            status: "success",
            message: "Successfully created new cloud variable",
          });
          getCloudVariables(apps[appIDIndex].PublicId);
        } else {
          setResult({
            status: "danger",
            message: "An unknown error has occurred",
          });
        }
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });

    setCreateShow(false);
  };

  const editSelectedVariable = () => {
    httpClient
      .put(`/private/variables/${selectedData.name}?app=${selectedData.app}&value=${selectedData.value}`, null, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        setResult({
          status: "success",
          message: `Successfully updated variable`,
        });

        getCloudVariables(selectedData.app);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });

    setEditShow(false);
  };

  // useEffect tells the component that it must do something after it has rendered
  useEffect(() => getApps(), []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Variables",
        columns: [
          {
            Header: "Name",
            accessor: "Name",
          },
          {
            Header: "Value",
            accessor: "Value",
          },
          {
            id: "edit",
            Header: "",
            accessor: (row) => {
              return row;
            },
            Cell: ({ value }) => (
              <Button
                variant="warning"
                onClick={() => {
                  setSelectedData({
                    app: value.app,
                    name: value.Name,
                    value: value.Value,
                  });
                  handleEditShow();
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            ),
          },
          {
            id: "del",
            Header: "",
            accessor: (d) => {
              return d;
            },
            Cell: ({ value }) => (
              <Button
                variant="danger"
                onClick={() => {
                  if (
                    window.confirm("Are you sure you want to delete this file?")
                  )
                    deleteCloudVariable(value.Name, value.app);
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <div className="Variables">
      <div className="mt-5">
        {result && (
          <Alert variant={result.status}>
            <span className="mr-1">
              <FontAwesomeIcon icon={statusToIcon[result.status]} />
            </span>
            <span>{result.message}</span>
          </Alert>
        )}

        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <div>
            <Form>
              <Form.Group controlId="appID">
                <Form.Label>App ID</Form.Label>
                <Form.Control
                  as="select"
                  onChange={handleChangeAppID}
                  defaultValue={`DEFAULT`}
                >
                  <option value="DEFAULT" disabled>
                    Select an app ID...
                  </option>
                  {apps.map((c, i) => {
                    return (
                      <option key={c.PublicId} value={i}>
                        {c.PublicId}
                      </option>
                    );
                  })}
                </Form.Control>
                <small className="form-text text-muted">
                  Select an app to show its API keys
                </small>
              </Form.Group>
            </Form>

            <div>
              {appIDIndex >= 0 && (
                <div>
                  <Table columns={columns} data={variables} />
                  {variables.length === 0 && (
                    <p className="text-center">No data available</p>
                  )}
                </div>
              )}
            </div>

            <div className="float-right">
              <Button variant="success" onClick={handleCreateShow}>
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </div>

            <Modal show={editShow} onHide={handleEditClose}>
              <Modal.Header closeButton>
                <Modal.Title>Edit variable</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <Form>
                  <Form.Group controlId="value">
                    <Form.Label>Value</Form.Label>
                    <Form.Control
                      type="text"
                      value={selectedData.value}
                      onChange={handleEditChange}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleEditClose}>
                  Cancel
                </Button>

                <Button variant="primary" onClick={editSelectedVariable}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={createShow} onHide={handleCreateClose}>
              <Modal.Header closeButton>
                <Modal.Title>Add cloud variable</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <Form>
                  <Form.Group controlId="name">
                    <Form.Label>Variable name</Form.Label>
                    <Form.Control
                      type="text"
                      value={createData.name}
                      onChange={handleCreateChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="value">
                    <Form.Label>Variable value</Form.Label>
                    <Form.Control
                      type="text"
                      value={createData.value}
                      onChange={handleCreateChange}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleCreateClose}>
                  Cancel
                </Button>

                <Button variant="primary" onClick={createCloudVariable}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/dashboard/Variables.js